import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private userSubject: BehaviorSubject<any>;
  public user: Observable<any>;

  constructor(private router: Router) {
    this.userSubject = new BehaviorSubject<any>(null);
    this.user = this.userSubject.asObservable();
    this.initializeUserFromToken();
  }

  private async initializeUserFromToken() {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = await jwtDecode(token);
        this.userSubject.next(decoded);
      } catch (error) {
        console.error('Error decoding token:', error);
        this.logout();
      }
    }
  }

  public get userValue(): any {
    return this.userSubject.value;
  }

  async completeAuthentication(response): Promise<void> {
    try {
      localStorage.setItem('token', response['token']);
      const decoded = await jwtDecode(response['token']);
      this.userSubject.next(decoded);
    } catch (error) {
      console.error('Error completing authentication:', error);
    }
  }

  async getToken(): Promise<string> {
    let token = localStorage.getItem('token');
    return token;
  }

  public async getUserFromToken() {
    const token = await this.getToken();
    if (token) {
      try {
        const decoded: any = await jwtDecode(token);
        return decoded;
      } catch (error) {
        console.error('Error decoding token:', error);
        return null;
      }
    }
    return null;
  }

  logout() {
    // remove token from local storage to log user out
    localStorage.removeItem('token');
    localStorage.removeItem('fcm_token');
    this.userSubject.next(null);
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }

  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }
}
